/* Build in libraries */

/* Third party libraries */

import AverageTimeAtResidenceWidget from '@/components/Rover/Widgets/AverageTimeAtResidenceWidget';
import TotalClients from '@/components/Rover/Widgets/TotalClientsWidget';
import TotalPropertiesWidget from '@/components/Rover/Widgets/TotalPropertiesWidget';
import Card from '@/components/UI/Card/index.tsx';
import DoughnutChart from '@/components/UI/Charts/DoughnutChart';
/* Components */
import PieChart from '@/components/UI/Charts/PieChart';

interface IApplicationDashboardComponentProps {
  data: any;
}

interface IDoughnutChart {
  dataLabels: string[];
  dataSets: { data: number; color: string }[];
}

interface IPieChart {
  label: string[];
  dataSets: { data: number; color: string }[];
}

export const GStrategiesApprovedDashboard = ({ data }: IApplicationDashboardComponentProps) => {
  const applicationsList = data?.data;
  const _staticColor = ['yellow', 'blue', 'gray', 'navy', 'green'];
  const widgetsData: {
    totalApprovedClients: number;
    totalApprovedLengthInYears: number;
    totalApprovedProperties: number;
    totalApplications: number;
    approvedIsPropertyIdentified: IDoughnutChart;
    approvedOwnAdditionalProperty: IDoughnutChart;
    approvedRentOrOwned: IDoughnutChart;
    approvedStructureOrVacantLot: IDoughnutChart;
    races: IPieChart;
    futureUseOfInterestedProperty: IPieChart;
    municipalities: { status: string; count: number }[];
    totalApprovedProjects: number;
    totalProposedSqft: number;
    statusSummary: { [key: string]: number };
    acquisitionTypes: { [key: string]: number };
    dealTypes: { [key: string]: number };
    constructionTypes: { [key: string]: number };
  } = {
    totalApprovedClients: 0,
    totalApprovedLengthInYears: 0,
    totalApprovedProperties: 0,
    totalApplications: applicationsList?.length,
    approvedIsPropertyIdentified: {
      dataLabels: ['Yes', 'No'],
      dataSets: [
        { data: 0, color: '#808080' },
        { data: 0, color: '#C2CFE0' },
      ],
    },

    approvedOwnAdditionalProperty: {
      dataLabels: ['Yes', 'No'],
      dataSets: [
        { data: 0, color: '#334D6E' },
        { data: 0, color: '#0FCA98' },
      ],
    },

    approvedRentOrOwned: {
      dataLabels: ['Own', 'Rent'],
      dataSets: [
        { data: 0, color: '#1F79B8' },
        { data: 0, color: '#0FCA98' },
      ],
    },
    approvedStructureOrVacantLot: {
      dataLabels: ['Structure', 'Vacant Lot'],
      dataSets: [
        { data: 0, color: '#D9B64E' },
        { data: 0, color: '#334D6E' },
      ],
    },

    races: {
      label: [
        'Black or African American',
        'White',
        'American Indian and Alaska Native',
        'Asian',
        'Native Hawaiian and Other Pacific Islander',
        'Two or more races',
      ],
      dataSets: [
        { data: 0, color: '#0FCA98' },
        { data: 0, color: '#D9B64E' },
        { data: 0, color: '#F27141' },
        { data: 0, color: '#2B6CB0' },
        { data: 0, color: '#808080' },
        { data: 0, color: '#334D6E' },
      ],
    },
    futureUseOfInterestedProperty: {
      label: ['Green space', 'Urban Agr./Homesteading', 'Small Business', 'Housing', 'Rental property'],
      dataSets: [
        { data: 0, color: '#0FCA98' },
        { data: 0, color: '#D9B64E' },
        { data: 0, color: '#2B6CB0' },
        { data: 0, color: '#808080' },
        { data: 0, color: '#334D6E' },
      ],
    },
    municipalities: [
      { status: 'Avalon', count: 0 },
      { status: 'Bellevue', count: 0 },
      { status: 'Blawnox', count: 0 },
      { status: 'Braddock Hills', count: 0 },
      { status: 'Carnegie', count: 0 },
      { status: 'Clairton', count: 0 },
      { status: 'Coraopolis', count: 0 },
      { status: 'East Pittsburgh', count: 0 },
      { status: 'Elizabeth Borough', count: 0 },
      { status: 'Forward', count: 0 },
      { status: 'Glassport', count: 0 },
      { status: 'Homestead', count: 0 },
      { status: 'McKees Rocks', count: 0 },
      { status: 'Millvale', count: 0 },
      { status: 'Mount Oliver', count: 0 },
      { status: 'North Braddock', count: 0 },
      { status: 'Pitcairn', count: 0 },
      { status: 'Rankin', count: 0 },
      { status: 'Sharpsburg', count: 0 },
      { status: 'Stowe', count: 0 },
      { status: 'Swissvale', count: 0 },
      { status: 'Turtle Creek', count: 0 },
      { status: 'Verona', count: 0 },
      { status: 'Versailles', count: 0 },
      { status: 'Wall', count: 0 },
      { status: 'Whitaker', count: 0 },
      { status: 'Whitaker and Wilmerding', count: 0 },
    ],
    totalApprovedProjects: 0,
    totalProposedSqft: 0,
    statusSummary: {},
    acquisitionTypes: {},
    dealTypes: {},
    constructionTypes: {},
  };

  applicationsList?.forEach((a: any) => {
    const { applicationData } = a;

    if (a.status === 'APPROVED') {
      widgetsData.totalApprovedClients += 1;

      //Total acquisition cost widget
      widgetsData.totalApprovedLengthInYears += Number(applicationData?.step1?.section2?.lengthInYears);
      //Total interested Properties widget
      widgetsData.totalApprovedProperties += applicationData?.step2?.interestedProperties?.length;

      // Own additional property
      if (applicationData?.step1?.section4?.ownedProperties.length > 0) {
        widgetsData.approvedOwnAdditionalProperty.dataSets[0].data += 1;
      } else {
        widgetsData.approvedOwnAdditionalProperty.dataSets[1].data += 1;
      }

      applicationData?.step2?.interestedProperties.forEach((ip: any) => {
        //  Structure or vacant lot
        if (ip?.propertyStatus === 'Structured') {
          widgetsData.approvedStructureOrVacantLot.dataSets[0].data += 1;
        }
        if (ip?.propertyStatus === 'Vacant Lot') {
          widgetsData.approvedStructureOrVacantLot.dataSets[1].data += 1;
        }
      });

      // Races

      if (applicationData?.step1.section1.race === 'Black or African American') {
        widgetsData.races.dataSets[0].data += 1;
      }
      if (applicationData?.step1.section1.race === 'White') {
        widgetsData.races.dataSets[1].data += 1;
      }
      if (applicationData?.step1.section1.race === 'American Indian and Alaska Native') {
        widgetsData.races.dataSets[2].data += 1;
      }
      if (applicationData?.step1.section1.race === 'Asian') {
        widgetsData.races.dataSets[3].data += 1;
      }
      if (applicationData?.step1.section1.race === 'Native Hawaiian and Other Pacific Islander') {
        widgetsData.races.dataSets[4].data += 1;
      }
      if (applicationData?.step1.section1.race === 'Two or more races') {
        widgetsData.races.dataSets[5].data += 1;
      }

      applicationData?.step2?.interestedProperties.forEach((ip: any) => {
        // Future use of interested property
        if (ip?.landUtilizationPlan === 'Green space') {
          widgetsData.futureUseOfInterestedProperty.dataSets[0].data += 1;
        }
        if (ip?.landUtilizationPlan === 'Urban Agr./Homesteading') {
          widgetsData.futureUseOfInterestedProperty.dataSets[1].data += 1;
        }
        if (ip?.landUtilizationPlan === 'Small Business') {
          widgetsData.futureUseOfInterestedProperty.dataSets[2].data += 1;
        }
        if (ip?.landUtilizationPlan === 'Housing') {
          widgetsData.futureUseOfInterestedProperty.dataSets[3].data += 1;
        }
        if (ip?.landUtilizationPlan === 'Rental property') {
          widgetsData.futureUseOfInterestedProperty.dataSets[4].data += 1;
        }

        // municipality breakdown
        if (ip?.municipality === 'Avalon') {
          widgetsData.municipalities[0].count += 1;
        }
        if (ip?.municipality === 'Bellevue') {
          widgetsData.municipalities[1].count += 1;
        }

        if (ip?.municipality === 'Blawnox') {
          widgetsData.municipalities[2].count += 1;
        }
        if (ip?.municipality === 'Braddock') {
          widgetsData.municipalities[3].count += 1;
        }
        if (ip?.municipality === 'Braddock Hills') {
          widgetsData.municipalities[4].count += 1;
        }
        if (ip?.municipality === 'Carnegie') {
          widgetsData.municipalities[5].count += 1;
        }
        if (ip?.municipality === 'Clairton') {
          widgetsData.municipalities[6].count += 1;
        }
        if (ip?.municipality === 'Coraopolis') {
          widgetsData.municipalities[7].count += 1;
        }
        if (ip?.municipality === 'East Pittsburgh') {
          widgetsData.municipalities[8].count += 1;
        }
        if (ip?.municipality === 'Elizabeth Borough') {
          widgetsData.municipalities[9].count += 1;
        }
        if (ip?.municipality === 'Forward') {
          widgetsData.municipalities[10].count += 1;
        }
        if (ip?.municipality === 'Glassport') {
          widgetsData.municipalities[11].count += 1;
        }
        if (ip?.municipality === 'Homestead') {
          widgetsData.municipalities[12].count += 1;
        }
        if (ip?.municipality === 'McKees Rocks') {
          widgetsData.municipalities[13].count += 1;
        }
        if (ip?.municipality === 'Millvale') {
          widgetsData.municipalities[14].count += 1;
        }
        if (ip?.municipality === 'Mount Oliver') {
          widgetsData.municipalities[15].count += 1;
        }
        if (ip?.municipality === 'North Braddock') {
          widgetsData.municipalities[16].count += 1;
        }
        if (ip?.municipality === 'Pitcairn') {
          widgetsData.municipalities[17].count += 1;
        }
        if (ip?.municipality === 'Rankin') {
          widgetsData.municipalities[18].count += 1;
        }
        if (ip?.municipality === 'Sharpsburg') {
          widgetsData.municipalities[19].count += 1;
        }
        if (ip?.municipality === 'Stowe') {
          widgetsData.municipalities[20].count += 1;
        }
        if (ip?.municipality === 'Swissvale') {
          widgetsData.municipalities[21].count += 1;
        }
        if (ip?.municipality === 'Sharpsburg') {
          widgetsData.municipalities[22].count += 1;
        }
        if (ip?.municipality === 'Tarentum') {
          widgetsData.municipalities[23].count += 1;
        }
        if (ip?.municipality === 'Turtle Creek') {
          widgetsData.municipalities[24].count += 1;
        }
        if (ip?.municipality === 'Verona') {
          widgetsData.municipalities[25].count += 1;
        }
        if (ip?.municipality === 'Versailles') {
          widgetsData.municipalities[26].count += 1;
        }
        if (ip?.municipality === 'Wall') {
          widgetsData.municipalities[27].count += 1;
        }
        if (ip?.municipality === 'Whitaker') {
          widgetsData.municipalities[28].count += 1;
        }
        if (ip?.municipality === 'Whitaker and Wilmerding') {
          widgetsData.municipalities[29].count += 1;
        }
      });

      // Have you identified a property?
      if (applicationData?.step2?.q1 === 'yes') {
        widgetsData.approvedIsPropertyIdentified.dataSets[0].data += 1;
      }
      if (applicationData?.step2?.q1 === 'no') {
        widgetsData.approvedIsPropertyIdentified.dataSets[1].data += 1;
      }

      // Properties Rent/Owned
      if (applicationData?.step1?.section2?.rentStatus.toLowerCase() === 'own') {
        widgetsData.approvedRentOrOwned.dataSets[0].data += 1;
      }
      if (applicationData?.step1?.section2?.rentStatus.toLowerCase() === 'rent') {
        widgetsData.approvedRentOrOwned.dataSets[1].data += 1;
      }
    }
  });

  const convertIntoPercentage = (arrayOfData: { data: number; color: string }[]) => {
    const totalData = arrayOfData.reduce((acc: number, currentData: { data: number; color: string }) => {
      return acc + currentData.data;
    }, 0);
    const percentage = arrayOfData?.map((d: { data: number; color: string }) => {
      const convertNumberIntoPercentage = (d.data * 100) / totalData;
      const convertFloatToInteger = Math.ceil(convertNumberIntoPercentage);
      return {
        ...d,
        data: convertFloatToInteger ? convertFloatToInteger : 0,
      };
    });

    return percentage;
  };

  return (
    <>
      <section className='grid md:grid-cols-2 xl:grid-cols-4 gap-4'>
        <TotalClients count={widgetsData?.totalApprovedClients ?? 0} />
        <AverageTimeAtResidenceWidget
          count={
            widgetsData?.totalApprovedLengthInYears && widgetsData?.totalApprovedClients
              ? widgetsData?.totalApprovedLengthInYears / widgetsData?.totalApprovedClients
              : 0
          }
        />
        <TotalPropertiesWidget count={widgetsData?.totalApprovedProperties ?? 0} />
      </section>
      <section className='my-4 grid md:grid-cols-4 xl:grid-cols-2 gap-4'>
        <Card title='Own additional property'>
          <div className='p-5 flex flex-col items-center '>
            <div className='w-5/6 lg:w-2/3 '>
              <DoughnutChart
                dataLabels={widgetsData?.approvedOwnAdditionalProperty?.dataLabels}
                datasets={convertIntoPercentage(widgetsData?.approvedOwnAdditionalProperty?.dataSets)}
                percentage={true}
              />
            </div>
          </div>
        </Card>
        <Card title='Have you identified a property?'>
          <div className='p-5 flex flex-col items-center '>
            <div className='w-5/6 lg:w-2/3 '>
              <DoughnutChart
                dataLabels={widgetsData?.approvedIsPropertyIdentified?.dataLabels}
                datasets={convertIntoPercentage(widgetsData?.approvedIsPropertyIdentified?.dataSets)}
                percentage={true}
              />
            </div>
          </div>
        </Card>
      </section>
      <section className='my-4 grid md:grid-cols-2 xl:grid-cols-2 gap-4'>
        <Card title='Rent vs Own'>
          <div className='p-5 flex flex-col items-center '>
            <div className='w-5/6 lg:w-2/3 '>
              <DoughnutChart
                dataLabels={widgetsData?.approvedRentOrOwned?.dataLabels}
                datasets={convertIntoPercentage(widgetsData?.approvedRentOrOwned?.dataSets)}
                percentage={true}
              />
            </div>
          </div>
        </Card>

        <Card title='Structure vs Vacant Lot'>
          <div className='p-5 flex flex-col items-center '>
            <div className='w-5/6 lg:w-2/3 '>
              <DoughnutChart
                dataLabels={widgetsData?.approvedStructureOrVacantLot?.dataLabels}
                datasets={convertIntoPercentage(widgetsData?.approvedStructureOrVacantLot?.dataSets)}
                percentage={true}
              />
            </div>
          </div>
        </Card>
      </section>

      <section className='my-4 grid md:grid-cols-2 xl:grid-cols-2 gap-4'>
        <div className='my-4'>
          <Card title='Demographics'>
            <div className='relative p-5 h-80'>
              <PieChart
                labels={widgetsData?.races.label}
                datasets={convertIntoPercentage(widgetsData?.races.dataSets)}
                chartTitle='Total Races'
                showValue={true}
              />
            </div>
          </Card>
        </div>
        {/* <div className="my-4">
            <Card title="Project Location">
              {applicationsList || (
                <div className="w-full flex justify-center flex-col items-center h-screen/2">
                  <div className="flex justify-center items-center gap-2 text-primaryColor-normal">
                    <MapPinIcon className="h-8 w-8" />
                    <h1>No Projects</h1>
                  </div>
                  <p>There are no assigned projects to display.</p>
                </div>
              )}
              {applicationsList?.length > 0 && (
              <div className="w-full grid grid-cols-6 h-screen/2">
                <div className="col-span-6 w-full border-l p-5">
                  <MapGoogle projectList={applicationsList} />
                </div>
              </div>
            )}
            </Card>
          </div> */}
      </section>

      <section className='my-4 grid md:grid-cols-2 xl:grid-cols-2 gap-4'>
        <div className='my-4'>
          <Card title='Future Use of Interested Property'>
            <div className='relative p-5 h-80'>
              <PieChart
                labels={widgetsData?.futureUseOfInterestedProperty.label}
                datasets={convertIntoPercentage(widgetsData?.futureUseOfInterestedProperty.dataSets)}
                showValue={true}
                chartTitle='Total Project Types'
              />
            </div>
          </Card>
        </div>
        <div className='my-4'>
          <Card title='Municipality Breakdown'>
            <div className='h-96 overflow-scroll'>
              {widgetsData?.municipalities?.map((s: any) => (
                <div key={s?.status} className='relative flex justify-between py-5 px-10 border-b'>
                  <div className='flex items-center gap-2 text-grey-700 w-full relative'>
                    <span>{s.status}</span>
                  </div>
                  <span className='text-xl font-bold'>{s.count}</span>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </section>
    </>
  );
};
